import { render } from "./DropdownInput.vue?vue&type=template&id=09b28d3a&scoped=true"
import script from "./DropdownInput.vue?vue&type=script&lang=js"
export * from "./DropdownInput.vue?vue&type=script&lang=js"

import "./DropdownInput.vue?vue&type=style&index=0&id=09b28d3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b28d3a"]])

export default __exports__